import React from "react";

const EmptyPage = () => {
  return <div></div>;
};

export default EmptyPage;
